import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { Injectable, inject, Injector, afterNextRender, runInInjectionContext } from '@angular/core';

import { ToastContainerComponent } from '../components/toast/toast-container.component';

@Injectable({
  providedIn: 'root'
})
export class ToastOverlayManager {
  private overlay = inject(Overlay);
  private injector = inject(Injector);
  private overlayRef?: OverlayRef;

  constructor() {
    // Bootstrap-only safe init: Ensure overlay container exists 
    // when the app is stable
    afterNextRender(() => {
      this.initOverlay();
    }, { injector: this.injector });
  }

  private initOverlay() {
    if (this.overlayRef) return;

    this.overlayRef = this.overlay.create({
      positionStrategy: this.overlay.position()
        .global()
        .bottom('20px')
        .left('20px'), // Match user's preferred position
      panelClass: 'toast-overlay-pane',
      scrollStrategy: this.overlay.scrollStrategies.noop()
    });

    const portal = new ComponentPortal(ToastContainerComponent);
    this.overlayRef.attach(portal);
  }

  // API to ensure initialization if called imperatively (e.g. from Interceptor)
  ensureInitialized() {
    if (!this.overlayRef) {
       runInInjectionContext(this.injector, () => {
         this.initOverlay();
       });
    }
  }
}
